<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import { BaseAtom } from "components/cards/atoms";
export let container = undefined;
</script>

<BaseAtom
  _isotope="FixturesStackedBAtom"
  {...container}
  _cssVariablePrefix="fixtures-stacked-b"
>
  vertical fixtures card
</BaseAtom>

<style>
  .team-form-card {
    width: 100%;
  }</style>